import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { promoActivityConfig } from "@/lib/datasetRegistry"
import { ActivityArchivePanel, type ArchiveSnapshot } from "./ActivityArchivePanel"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `promoActivityConfig` (app/frontend/lib/datasetRegistry.ts). The
// controller renders this via inertia page name "admin/promo_activity/Uploads".
//
// Feature #49 M4: the controller also passes `activity_plan_archive` (read-only
// archive stats per recent mkt_activity_plan snapshot); this module turns it into
// the typed `archivePanel` slot so the registry stays data-only (no JSX there).
type Props = Omit<DatasetUploadsPageProps, "config" | "archivePanel"> & {
  activity_plan_archive?: ArchiveSnapshot[]
}

export default function AdminPromoActivityUploads({ activity_plan_archive, ...props }: Props) {
  return (
    <DatasetUploadsPage
      config={promoActivityConfig}
      archivePanel={<ActivityArchivePanel snapshots={activity_plan_archive ?? []} />}
      {...props}
    />
  )
}
